module.exports = "<div class=\"q-input-and-icon q-marg-bottom-md\"> <input type=email class=\"q-input q-stretch email-recipient\" placeholder=\"Enter email address\"/> <a class=q-text-center href=#> <i class=\"fa fa-times fa-lg q-link-icon remove-email-row\"></i> </a> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/billingInformation/html/emailLine.html
// module id = 1243
// module chunks = 1